export const mediaWidth = '(min-width:900px)';